import Vue from "vue";
import VueI18n from "vue-i18n";

// Import Translation
import enTranslations from "../../../lang/en.json";
import frTranslations from "../../../lang/fr.json";
import nlTranslations from "../../../lang/nl.json";
import enAstroTranslations from "../../../lang/en-astro.json";
import frAstroTranslations from "../../../lang/fr-astro.json";
import nlAstroTranslations from "../../../lang/nl-astro.json";


const defaultLocale = "fr";
const locale = "fr";

// Build translations object
const translations = {
    en: enTranslations,
    fr: frTranslations,
    nl: nlTranslations,
    "en-astro": enAstroTranslations,
    "fr-astro": frAstroTranslations,
    "nl-astro": nlAstroTranslations
};

Vue.use(VueI18n);

// Create VueI18n instance with options
const i18n = new VueI18n({
    locale: locale,
    fallbackLocale: defaultLocale,
    messages: translations,
    silentTranslationWarn: true
});
export { i18n };